import {inject} from '@angular/core';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {WidgetConfigService} from '@wellfit/wf-plans-widget';
import {EventsManager} from 'src/app/services/events.manager';
import {StateInterface} from 'src/app/interfaces/state.interface';
import {ADHA_STATE} from 'src/app/constants/purchase.constant';

function storedStateAbbreviation(): string | undefined {
  try {
    const state: StateInterface | null = JSON.parse(sessionStorage.getItem('state') ?? 'null');
    return state?.abbr || undefined;
  } catch {
    return undefined;
  }
}

export const purchaseOptionsGuard: CanActivateFn = (): boolean | UrlTree => {
  const eventsManager: EventsManager = inject(EventsManager);
  const widgetConfigService: WidgetConfigService = inject(WidgetConfigService);

  if (eventsManager.purchaseIsADHA) {
    widgetConfigService.setOptions({...widgetConfigService.getOptions(), practiceId: eventsManager.adhaPractice, state: ADHA_STATE});
    return true;
  }

  const state: string | undefined = storedStateAbbreviation();
  if (!state) {
    return inject(Router).createUrlTree(['/']);
  }

  widgetConfigService.setOptions({...widgetConfigService.getOptions(), practiceId: undefined, state});
  return true;
};
